module.exports = __webpack_public_path__ + "static/media/phone.6e3b345b.svg";